import React from 'react'

import { FilterButton, Filters } from 'components'

import constants from 'constants/index'

const FiltersComponent = ({ filter = {}, mySuppliers = true }) => {
  const { PROGRESS_STATS_CARD_ITEMS } = constants.companySuppliers

  return (
    <>
      <FilterButton setDrawerOpen={filter.setDrawerOpen} />

      {mySuppliers ? (
        <Filters
          filter={filter}
          alphabeticalOrder
          alphabeticalFieldOrder="suppliers.name"
        >
          <input textfieldinput="true" label="Identificador" name="id" />

          <input
            textfieldinput="true"
            label="Razão Social"
            name="supplier_name"
          />

          <input
            textfieldinput="true"
            label="Documento"
            name="supplier_document"
          />

          <select
            textfieldinput="true"
            label="Progresso"
            name="progress_status"
          >
            <option value=""></option>
            {PROGRESS_STATS_CARD_ITEMS.map((item) => (
              <option key={item.status} value={item.status}>
                {item.subTitle}
              </option>
            ))}
          </select>
        </Filters>
      ) : (
        <Filters
          filter={filter}
          alphabeticalOrder
          alphabeticalFieldOrder="companies.name"
        >
          <input textfieldinput="true" label="Identificador" name="id" />

          <input
            textfieldinput="true"
            label="Razão Social"
            name="company_name"
          />

          <input
            textfieldinput="true"
            label="Documento"
            name="company_document"
          />
        </Filters>
      )}
    </>
  )
}

export default FiltersComponent
